module.exports = __webpack_public_path__ + "img/input_1.dfbd3293.png";